import styled from 'styled-components';

import { SvgContainer } from '../../../shared/SvgIcon';

const Col = styled.div`
  padding: 15px 30px;
  display: flex;
  align-items: center;
  @media (max-width: 1640px) {
    padding: 15px;
  }
`;

export const NameCol = styled(Col)`
  flex: 1 1 72%;
  max-width: 495px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block !important;
  padding-left: 15px;
  @media (max-width: 1640px) {
    max-width: 420px;
  }
  @media (max-width: 1440px) {
    flex-basis: 62%;
  }
  @media (max-width: 1280px) {
    max-width: 100%;
    flex-basis: auto;
  }

  ${SvgContainer} {
    display: inline-block;
    height: 14px;
    width: 14px;
    margin-bottom: -9px;
    margin-left: -4px;
  }
`;

export const ProgressCol = styled(Col)`
  display: flex;
  flex-wrap: nowrap;
  flex: 0 0 205px;

  span {
    margin-right: 15px;
  }

  @media (max-width: 1640px) {
    flex-basis: 175px;
  }

  @media (max-width: 675px) {
    display: none;
  }
`;

export const StatusCol = styled(Col)`
  flex: 0 0 165px;
  @media (max-width: 1640px) {
    flex-basis: 135px;
  }
  @media (max-width: 815px) {
    display: none;
  }
`;

export const DueDateCol = styled(Col)`
  flex: 0 0 150px;
  @media (max-width: 1640px) {
    flex-basis: 120px;
  }
  @media (max-width: 950px) {
    display: none;
  }
`;

export const OwnersCol = styled(Col)`
  flex: 0 0 170px;
  @media (max-width: 1640px) {
    flex-basis: 140px;
  }
  @media (max-width: 1280px) {
    display: none;
  }
`;

export const LabelsCol = styled(Col)`
  flex: 1 1 28%;
  min-width: 104px;
  overflow: hidden;
  padding-right: 15px;
  @media (max-width: 1440px) {
    flex: 1 1 38%;
  }
  @media (max-width: 1280px) {
    display: none;
  }
`;
